import { useState,useRef } from "react";
import { NavLink } from "react-router-dom";
import insertNewLines from "../../../../../utilities/insertNewLines";
import DelayedText1 from "../../../../About/components/DelayedText1";
import scrollToTop from "../../../../../utilities/scrollToTop";

function Ternary_Conditional_Operator() {
  const title = 'Ternary Conditional Operator'

  const paragraphs = {

    first: [insertNewLines(` Basic syntax:$4$@@$4$
    >$4$@@$4$
    a ? b : c$4$@@$4$
    <$4$@@$4$
    $4$@@$4$
    a = test condition $4$@@$4$
    b = code to run if test is true$4$@@$4$
    c = code to run if test is false$4$@@$4$
    $4$@@$4$
    example:$4$@@$4$
    >>$4$@@$4$
    let a = 1;$4$@@$4$
    let b = 2;$4$@@$4$
    $4$@@$4$
    return (a < b) ? “a is less than b” : “b is not larger than a”; $4$@@$4$
    <<$4$@@$4$
    the ternary statement above will return one of either strings, based on the outcome of the test (the first one in the case).$4$@@$4$
    Hence, it is the same as the code: $4$@@$4$
    >>$4$@@$4$
    if(a < b){$4$@@$4$
    $4$%%$4$return “a is less than b”;$4$@@$4$
    }else{$4$@@$4$
    $4$%%$4$return “b is not larger than a”;$4$@@$4$
    }$4$@@$4$
    <<$4$@@$4$
    notice how in the ternary statement, there is only need for 1 return keyword. $4$@@$4$
    $4$@@$4$
    In order to chain multiple ternary operators, as in an if-else if statement:$4$@@$4$
    >$4$@@$4$
    a ? b : a2 ? b2 : a3 ? b3… $4$@@$4$
    <$4$@@$4$
    $4$@@$4$
    In this case, every a is a test and every b is an outcome (the code to be executed upon a true test), you can look at every a as an if keyword and every *:* as an else keyword, and lastly every b = the code block$4$@@$4$
    $4$@@$4$
    hence, this would be the same as:$4$@@$4$
    >$4$@@$4$
    if(a){…b…}else if(a2){…b2…}else if(a3){…b3…}$4$@@$4$
    <$4$@@$4$
    $4$@@$4$
    And an actual example, following the former values for a and b:$4$@@$4$
    >>$4$@@$4$
    return (a < b) ? "b is larger than a" $4$@@$4$
    : (a == b) ? "a and b are equal"$4$@@$4$
    : (a > b) ? "a is larger than b";$4$@@$4$
    <<$4$@@$4$
    $4$@@$4$
    As standard practice, it is accepted that, everytime there are is a colon -- : -- to begin on a new line for extra readability and clarity.
    `)],

    second: [],

    third: [],

    forth: [],

    fifth: [],

    sixth: [],

    seventh: [],
  }

  const [colorMode,setColorMode] = useState(JSON.parse(localStorage.getItem("lightMode")))

  function handleColorModeClick(){
    localStorage.setItem("lightMode", JSON.stringify(!colorMode))
      setColorMode(JSON.parse(localStorage.getItem("lightMode")))
  }
  
  return (
    <div  className={colorMode ? 'BlogPage lightMode' : 'BlogPage'}>
      <button className='blog-page-color-mode-btn' onClick={handleColorModeClick} >
      {colorMode && <DelayedText1 type={69} content="DAY MODE" typeSpeed={50} characterIterations={3} switch={false}/>}
      {!colorMode && <DelayedText1 type={69} content="NIGHT MODE" typeSpeed={50} characterIterations={3} switch={false}/>}
      </button>
      <div className="key-container">
          <div>
              <h3>Key:</h3>
              <h4><span>{">> ... <<"}</span> <span>: literal code example</span></h4>
              <h4><span>{"> ... <"}</span> <span>: pseudo code example</span></h4>
              <h4><span>{"- ... -"}</span> <span>: quoting a string/value</span></h4>
              <h4><span>{"-- ... --"}</span> <span>: quoting a symbol</span></h4>
          </div>
        </div>
        <h1>{title}</h1>
        <hr className="splitter-hr"/>
        <div className='blog-page-container' >
          {paragraphs.first.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.first[0] && <hr className="splitter-hr"/>}

          {paragraphs.second.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.second[0] && <hr className="splitter-hr"/>}

          {paragraphs.third.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.third[0] && <hr className="splitter-hr"/>}

          {paragraphs.forth.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.forth[0] && <hr className="splitter-hr"/>}

          {paragraphs.fifth.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.fifth[0] && <hr className="splitter-hr"/>}

          {paragraphs.sixth.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.sixth[0] && <hr className="splitter-hr"/>}

          {paragraphs.seventh.map((element, index) => <p key={element[0] + (element.length / 3).toFixed(0) + index}>{element}</p>)}
          {paragraphs.seventh[0] && <hr className="splitter-hr"/>}
        </div>
        <div className='back-nav-container'>
        <NavLink to='/blog' onClick={scrollToTop}><button className="blog-return-btn" >BACK TO BLOG</button></NavLink>
        </div>
    </div>
  );
  }
  
  export default Ternary_Conditional_Operator;
  